import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';


class UploadService {
  /**
   * Upload proof of business document
   * @param {File} file - File to upload
   * @param {Function} onProgress - Progress callback
   * @returns {Promise} Upload response
   */
  async uploadProofOfBusiness(file, onProgress) {
    try {
      const formData = new FormData();
      formData.append('document', file);

      const token = localStorage.getItem('token');

      const response = await axios.post(
        `${API_URL}/upload/proof-of-business`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          },
          onUploadProgress: (progressEvent) => {
            if (onProgress && progressEvent.total) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              onProgress(percentCompleted);
            }
          }
        }
      );

      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      throw new Error(
        error.response?.data?.message || 'Failed to upload proof of business document'
      );
    }
  }

  /**
   * Upload photo ID document
   * @param {File} file - File to upload
   * @param {Function} onProgress - Progress callback
   * @returns {Promise} Upload response
   */
  async uploadPhotoId(file, onProgress) {
    try {
      const formData = new FormData();
      formData.append('document', file);

      const token = localStorage.getItem('token');

      const response = await axios.post(
        `${API_URL}/upload/photo-id`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          },
          onUploadProgress: (progressEvent) => {
            if (onProgress && progressEvent.total) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              onProgress(percentCompleted);
            }
          }
        }
      );

      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      throw new Error(
        error.response?.data?.message || 'Failed to upload photo ID document'
      );
    }
  }

  /**
   * Delete proof of business document
   * @returns {Promise} Delete response
   */
  async deleteProofOfBusiness() {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.delete(
        `${API_URL}/upload/proof-of-business`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      throw new Error(
        error.response?.data?.message || 'Failed to delete proof of business document'
      );
    }
  }

  /**
   * Delete photo ID document
   * @returns {Promise} Delete response
   */
  async deletePhotoId() {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.delete(
        `${API_URL}/upload/photo-id`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      throw new Error(
        error.response?.data?.message || 'Failed to delete photo ID document'
      );
    }
  }

  /**
   * Get signed URL for viewing document
   * @param {String} documentType - 'proof-of-business' or 'photo-id'
   * @returns {Promise} Signed URL response
   */
  async getDocumentUrl(documentType) {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.get(
        `${API_URL}/upload/document/${documentType}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      throw new Error(
        error.response?.data?.message || 'Failed to get document URL'
      );
    }
  }
}

export default new UploadService();
